import React, { useEffect, useRef, useState } from "react";
import "./Header.css";
import { FaBars } from "react-icons/fa";
import FalconLogo from "../../assets/main-logo.png";
import { useMsal } from "@azure/msal-react";
import PropTypes from "prop-types";

const Header = ({ isOpen, setIsOpen }) => {
  const { instance } = useMsal();
  const menuRef = useRef(null);
  const [loggedInUser, setLoggedInUser] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleDropdown = () => setIsMenuOpen(!isMenuOpen);

  const handleLogout = () => {
    instance.logout().catch((e) => {
      console.error(e);
    });
  };

  // Close the profile dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Derive the signed-in user's display name from the MSAL account
  useEffect(() => {
    try {
      const accountKeys = JSON.parse(
        sessionStorage.getItem("msal.account.keys"),
      );
      if (accountKeys?.length) {
        const account = JSON.parse(sessionStorage.getItem(accountKeys[0]));
        setLoggedInUser(account?.name?.split(" ") || "");
      }
    } catch (error) {
      console.error("Failed to read logged-in user:", error);
    }
  }, []);

  const loggedInEmail = (() => {
    try {
      const accountKeys = JSON.parse(
        sessionStorage.getItem("msal.account.keys"),
      );
      if (accountKeys?.length) {
        const account = JSON.parse(sessionStorage.getItem(accountKeys[0]));
        return account?.username || "";
      }
    } catch {
      return "";
    }
    return "";
  })();

  return (
    <header className="header">
      <button
        className="sidebar-toggle mr-2"
        onClick={() => setIsOpen(!isOpen)}
      >
        <FaBars size={18} />
      </button>
      <div className="flex items-center header-icon-joyride-class">
        <div className="left-section flex items-center">
          <div className="flex items-center">
            <img src={FalconLogo} alt="NextGenlytics Logo" className="logo" />
            <div className="hidden sm:flex items-center -ml-2">
              <span className="font-semibold text-gray-900 text-[17px] tracking-tight">
                BlueGecko
              </span>
              <span className="mx-2.5 text-gray-300 font-light text-xl">/</span>
            </div>
          </div>
        </div>

        <div className="flex items-center -ml-1 sm:-ml-4 z-10">
          <span className="text-[17px] font-semibold tracking-tight text-gray-900 px-2.5 py-1.5">
            Admin
          </span>
        </div>
      </div>

      <div
        className="relative w-full max-w-md mx-auto invisible"
        style={{ fontSize: "14px", color: "#6b7280" }}
      >
        <span className="absolute inset-y-0 left-0 flex items-center pl-3">
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1117.5 10a7.5 7.5 0 01-4.85 6.65z"
            />
          </svg>
        </span>
        <input
          type="text"
          placeholder="Search objects, modules & mapping progress"
          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 text-sm text-gray-700"
        />
      </div>
      <div className="user-info">
        <div className="relative" ref={menuRef}>
          {/* Avatar Button */}
          <button
            type="button"
            onClick={toggleDropdown}
            className="flex items-center justify-center w-10 h-10 rounded-full bg-yellow-500 text-white font-bold cursor-pointer header-profile-joyride-class"
            aria-label="Toggle user menu"
          >
            {loggedInUser[0]?.charAt(0)}
            {loggedInUser.length > 1 && loggedInUser.at(-1)?.charAt(0)}
          </button>

          {/* Dropdown */}
          {isMenuOpen && (
            <div className="absolute right-0 mt-2 w-auto bg-white rounded-lg shadow-xl border z-50">
              {/* Header */}
              <div className="flex items-center justify-between px-4 py-3 border-b">
                <span className="font-semibold text-gray-800">BlueGecko</span>
                <button
                  onClick={handleLogout}
                  className="text-sm text-blue-600 hover:underline"
                >
                  Sign out
                </button>
              </div>

              {/* Profile Info */}
              <div className="flex items-center gap-[12px] px-4 py-4">
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-yellow-500 text-white font-bold">
                  {loggedInUser[0]?.charAt(0)}
                  {loggedInUser.length > 1 && loggedInUser.at(-1)?.charAt(0)}
                </div>
                <div className="flex flex-col">
                  <span className="font-medium text-gray-900">
                    {loggedInUser[0]}{" "}
                    {loggedInUser.length > 1 && loggedInUser.at(-1)}
                  </span>
                  <span className="text-sm text-gray-600">{loggedInEmail}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};

export default Header;
